import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

import {
    ROLE_ADMIN_CONSTANT,
    ROLE_ADMIN_LABEL,
    ROLE_COMMUNICATION_CONSTANT,
    ROLE_COMMUNICATION_LABEL,
    ROLE_MODERATOR_AND_HANDLER_CONSTANT,
    ROLE_MODERATOR_AND_HANDLER_LABEL,
    ROLE_SUPER_ADMIN_CONSTANT,
    ROLE_SUPER_ADMIN_LABEL,
    ROLE_SUPERVISOR_CONSTANT,
    ROLE_SUPERVISOR_LABEL,
    ROLE_USER_CONSTANT,
    ROLE_USER_LABEL
} from "@/constants/ConstantRole"

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

export const getContrastColorClass = (hexColor) => {
    // Handle undefined or null color
    if (!hexColor) {
        return 'text-black' // Default to black if no color
    }

    // Remove # if present
    const cleanColor = hexColor.replace('#', '')

    // Validate color length
    if (cleanColor.length !== 6) {
        return 'text-black' // Default to black for invalid colors
    }

    // Convert hex to RGB
    const r = parseInt(cleanColor.substr(0, 2), 16)
    const g = parseInt(cleanColor.substr(2, 2), 16)
    const b = parseInt(cleanColor.substr(4, 2), 16)

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

    // Return appropriate text color based on background brightness
    return luminance > 0.5 ? 'text-black' : 'text-white'
}

export const getContrastColorHex = (hexColor) => {
    // Handle undefined or null color
    if (!hexColor) {
        return '#000000' // Default to black if no color
    }

    // Remove # if present
    const cleanColor = hexColor.replace('#', '')

    // Validate color length
    if (cleanColor.length !== 6) {
        return '#000000' // Default to black for invalid colors
    }

    // Convert hex to RGB
    const r = parseInt(cleanColor.substr(0, 2), 16)
    const g = parseInt(cleanColor.substr(2, 2), 16)
    const b = parseInt(cleanColor.substr(4, 2), 16)

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

    // Return appropriate text color based on background brightness
    return luminance > 0.5 ? '#000000' : '#FFFFFF'
}

export const truncate = (contentSnippet, length = 160) => {
    return contentSnippet.length > length
        ? contentSnippet.slice(0, length - 1) + "…"
        : contentSnippet
}

export const maxRoleHelper = (roles) => {

    if (!roles) return ""

    let role = ROLE_USER_CONSTANT

    switch (true) {
        case roles.includes(ROLE_MODERATOR_AND_HANDLER_CONSTANT):
            role = ROLE_MODERATOR_AND_HANDLER_CONSTANT
            break

        case roles.includes(ROLE_COMMUNICATION_CONSTANT):
            role = ROLE_COMMUNICATION_CONSTANT
            break

        case roles.includes(ROLE_SUPERVISOR_CONSTANT):
            role = ROLE_SUPERVISOR_CONSTANT
            break

        case roles.includes(ROLE_ADMIN_CONSTANT):
            role = ROLE_ADMIN_CONSTANT
            break

        case roles.includes(ROLE_SUPER_ADMIN_CONSTANT):
            role = ROLE_SUPER_ADMIN_CONSTANT
            break
        default:
            role = ROLE_USER_CONSTANT
            break
    }

    return role
}

export const maxRoleHelperString = (roles) => {

    if (!roles) return ""

    if (roles.includes(ROLE_SUPER_ADMIN_CONSTANT)) return ROLE_SUPER_ADMIN_LABEL
    if (roles.includes(ROLE_ADMIN_CONSTANT)) return ROLE_ADMIN_LABEL
    if (roles.includes(ROLE_MODERATOR_AND_HANDLER_CONSTANT)) return ROLE_MODERATOR_AND_HANDLER_LABEL
    if (roles.includes(ROLE_COMMUNICATION_CONSTANT)) return ROLE_COMMUNICATION_LABEL
    if (roles.includes(ROLE_SUPERVISOR_CONSTANT)) return ROLE_SUPERVISOR_LABEL

    return ROLE_USER_LABEL
}